<template>
  <div>
    <div class="content-wrapper">
      <section class="content-header">
        <h1>
          Gestion des notifications
          <small>Administration</small>
        </h1>
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name: 'Dashboard'}">
              <i class="fa fa-dashboard"></i> Accueil
            </router-link>
          </li>
          <li class="active">Notifications</li>
        </ol>
      </section>

      <section class="content">
        <!-- FORMULAIRE NOUVELLE NOTIFICATION -->
        <div class="row">
          <div class="col-md-12">
            <div class="box" :class="showForm ? 'box-primary' : 'box-default collapsed-box'">
              <div class="box-header with-border" style="cursor:pointer;" @click="showForm = !showForm">
                <h3 class="box-title"><i class="fa fa-plus"></i> Nouvelle notification</h3>
                <div class="box-tools pull-right">
                  <button type="button" class="btn btn-box-tool">
                    <i :class="showForm ? 'fa fa-minus' : 'fa fa-plus'"></i>
                  </button>
                </div>
              </div>
              <div class="box-body" v-show="showForm">
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <label>Titre</label>
                      <input type="text" class="form-control" v-model="form.title" placeholder="Ex: Nouveautés v2.6.0">
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Version (optionnel)</label>
                      <input type="text" class="form-control" v-model="form.version" placeholder="Ex: 2.6.0">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Contenu</label>
                      <quillEditor ref="notifEditor"
                                   v-model="form.content"
                                   :options="editorOption">
                      </quillEditor>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-footer" v-show="showForm">
                <button class="btn btn-primary pull-right" @click.prevent="publishNotification" :disabled="publishing || !form.title || !form.content">
                  <i :class="publishing ? 'fa fa-spinner fa-spin' : 'fa fa-send'"></i>
                  Publier
                </button>
                <button class="btn btn-default" @click.prevent="resetForm">
                  Annuler
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- LISTE DES NOTIFICATIONS -->
        <div class="row">
          <div class="col-md-12">
            <div class="box box-primary">
              <div class="overlay" v-if="loading">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div class="box-header with-border">
                <h3 class="box-title"><i class="fa fa-bell"></i> Notifications publiées</h3>
                <button class="btn btn-default btn-xs pull-right" @click.prevent="loadNotifications">
                  <i class="fa fa-refresh"></i>
                </button>
              </div>
              <div class="box-body">
                <table class="table table-hover table-striped" v-if="notifications.length > 0">
                  <thead>
                    <tr>
                      <th style="width:50px;">#</th>
                      <th>Titre</th>
                      <th style="width:100px;">Version</th>
                      <th style="width:150px;">Date</th>
                      <th style="width:80px;">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="notif in notifications" :key="notif.id">
                      <td>{{ notif.id }}</td>
                      <td>
                        <a href="#" @click.prevent="togglePreview(notif.id)">{{ notif.title }}</a>
                        <div v-if="previewId === notif.id" class="notif-preview" v-html="notif.content"></div>
                      </td>
                      <td><span class="label label-info" v-if="notif.version">v{{ notif.version }}</span></td>
                      <td>{{ formatDate(notif.created_at) }}</td>
                      <td>
                        <button class="btn btn-xs btn-default" @click.prevent="togglePreview(notif.id)" :title="previewId === notif.id ? 'Masquer' : 'Apercu'">
                          <i :class="previewId === notif.id ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="text-center text-muted" v-if="!loading && notifications.length === 0">
                  <p>Aucune notification publiée.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {quillEditor} from 'vue-quill-editor'
var moment = require('moment')

export default {
  data() {
    return {
      loading: false,
      publishing: false,
      showForm: false,
      previewId: null,
      notifications: [],
      form: {
        title: '',
        version: '',
        content: '',
      },
      editorOption: {
        placeholder: 'Contenu de la notification...',
      },
    }
  },
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
    }),
  },
  mounted() {
    this.loadNotifications()
  },
  methods: {
    loadNotifications() {
      this.loading = true
      this.$http.get(this.getRoute('Notifications.all')).then((response) => {
        this.notifications = Array.isArray(response.body) ? response.body : (response.body.data || [])
        this.loading = false
      }, () => {
        this.notifications = []
        this.loading = false
      })
    },
    publishNotification() {
      if (!this.form.title || !this.form.content) return
      this.publishing = true
      let payload = {
        title: this.form.title,
        content: this.form.content,
      }
      if (this.form.version) payload.version = this.form.version
      this.$http.post(this.getRoute('Notifications.store'), JSON.stringify(payload)).then((response) => {
        this.$noty.success('Notification publiée')
        this.resetForm()
        this.publishing = false
        this.loadNotifications()
      }, () => {
        this.$noty.error('Erreur lors de la publication')
        this.publishing = false
      })
    },
    resetForm() {
      this.form.title = ''
      this.form.version = ''
      this.form.content = ''
      this.showForm = false
    },
    togglePreview(id) {
      this.previewId = this.previewId === id ? null : id
    },
    formatDate(date) {
      if (!date) return ''
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
  },
  components: {
    quillEditor,
  }
}
</script>

<style scoped>
.notif-preview {
  margin-top: 8px;
  padding: 10px 12px;
  background: #f9f9f9;
  border: 1px solid #eee;
  border-radius: 4px;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/Administration/AdminNotifications.vue